import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { SwatchColorPickerBase } from '/druid/SwatchColorPicker.base';
import {
  ISwatchColorPickerProps,
  ISwatchColorPickerStyles,
  ISwatchColorPickerStyleProps,
} from '/druid/SwatchColorPicker.types';
import { getStyles } from '/druid/SwatchColorPicker.styles';

export const SwatchColorPicker: React.FunctionComponent<ISwatchColorPickerProps> = styled<
  ISwatchColorPickerProps,
  ISwatchColorPickerStyleProps,
  ISwatchColorPickerStyles
>(SwatchColorPickerBase, getStyles, undefined, { scope: 'SwatchColorPicker' });
